import * as React from 'react';
import { useSelector } from 'react-redux';
import Head from 'next/head';

import { selectPMPEnabled } from 'ducks/server/settings';
import { selectBookingWidgetBannerImageUrls } from 'lib/util/bookingWidgetDesign';
import { selectTopPageBannerImageUrl } from 'lib/util/privateMarketplace';

export const OgpImageUrl = (): any => {
  const pmpEnabled = useSelector(selectPMPEnabled);

  let ogpImageUrl = '';
  if (pmpEnabled) {
    ogpImageUrl = useSelector(selectTopPageBannerImageUrl);
  } else {
    const bannerImageUrls = useSelector(selectBookingWidgetBannerImageUrls);
    if (bannerImageUrls.length > 0) {
      ogpImageUrl = bannerImageUrls[0];
    }
  }

  return <Head>{ogpImageUrl && <meta property="og:image" content={ogpImageUrl} />}</Head>;
};
